import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Teny Zaraina
export const getAllTenyZaraina = async () => {
  try {
    const response = await axios.get(`${baseUrl}/tenyzaraina`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Teny Zaraina:', error);
    return [];
  }
}

// get Teny Zaraina by Id
export const getTenyZarainaById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/tenyzaraina/${id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Teny Zaraina by Id ${id}:`, error);
    return null;
  }
}

// add Teny Zaraina
export const addTenyZaraina = async (tenyZaraina) => {
  try {
    const response = await axios.post(`${baseUrl}/tenyzaraina`, tenyZaraina);
    return response;
  } catch (error) {
    console.error( "erreur lors de l'ajout du tenyZaraina", error);
    return error;
  }
}

// update Teny Zaraina by Id
export const updateTenyZarainaById = async (id, tenyZaraina) => {
  try {
    const response = await axios.patch(`${baseUrl}/tenyzaraina/${id}`, tenyZaraina);
    return response;
  } catch (error) {
    console.error(`erreur lors de la modification du tenyZaraina by id ${id}:`, error);
    return error.response;
  }
}

// delete Teny Zaraina by Id
export const deleteTenyZarainaById = async (id) => {
  try {
    const response = await axios.delete(`${baseUrl}/tenyzaraina/${id}`);
    return response;
  } catch (error) {
    console.error(`erreur lors de la supression du Teny Zaraina ${id}:`, error);
    return error.response;
  }
}
